import { useCallback, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useReveal } from "@/hooks/use-reveal";
import { whatsappLink } from "@/content/liane-site.ar";
import w1 from "@/assets/liane/work-1.jpg";
import w2 from "@/assets/liane/work-3.jpg";
import w3 from "@/assets/liane/work-4.jpg";
import w4 from "@/assets/liane/work-5.jpg";
import w7 from "@/assets/liane/work-7.jpg";
import w8 from "@/assets/liane/work-8.jpg";
import w9 from "@/assets/liane/work-9.jpg";
import w10 from "@/assets/liane/work-10.jpg";
import w11 from "@/assets/liane/work-11.jpg";
import w12 from "@/assets/liane/work-12.jpg";
import w13 from "@/assets/liane/work-13.jpg";
import w14 from "@/assets/liane/work-14.jpg";
import w15 from "@/assets/liane/work-15.jpg";
import w16 from "@/assets/liane/work-16.jpg";
import w17 from "@/assets/liane/work-17.jpg";
import w18 from "@/assets/liane/work-18.jpg";
import w19 from "@/assets/liane/work-19.jpg";
import w21 from "@/assets/liane/work-21.jpg";
import w22 from "@/assets/liane/work-22.jpg";
import w23 from "@/assets/liane/work-23.jpg";
import w24 from "@/assets/liane/work-24.jpg";
import w25 from "@/assets/liane/work-25.jpg";
import w26 from "@/assets/liane/work-26.jpg";
import w27 from "@/assets/liane/work-27.jpg";
import w28 from "@/assets/liane/work-28.jpg";
import w29 from "@/assets/liane/work-29.jpg";
import w30 from "@/assets/liane/work-30.jpg";
import w31 from "@/assets/liane/work-31.jpg";
import w32 from "@/assets/liane/work-32.jpg";

type Work = { src: string; title: string; tag: string; alt: string };

const works: Work[] = [
  {
    src: w4,
    title: "بوكيه ليان الفاخر",
    tag: "هدايا مناسبات",
    alt: "بوكيه ورد من صابون ليان بتغليف أبيض وذهبي وشريطة وردية",
  },
  {
    src: w10,
    title: "بوكيه الورد الروزي",
    tag: "الأكثر طلبًا",
    alt: "بوكيه صابون ليان بورود وردية وبيج بتغليف مزهّر وشريطة بيضاء",
  },
  {
    src: w9,
    title: "بوكس التيفاني",
    tag: "بوكسات مميزة",
    alt: "بوكس صابون ليان بدرجات التركوازي مع زهور جبسوفيليا وشريطة",
  },
  {
    src: w2,
    title: "توزيعات الورد الوردي",
    tag: "توزيعات بأسماء",
    alt: "توزيعات صابون على شكل وردة وردية مع بطاقة اسم وشريطة ذهبية",
  },
  {
    src: w11,
    title: "بوكس اللافندر",
    tag: "هدايا فاخرة",
    alt: "بوكس صابون ليان بلون اللافندر مع زهور ليلكية وشريطة بنفسجية",
  },
  {
    src: w7,
    title: "بوكيه الروز الأبيض",
    tag: "الأكثر مبيعًا",
    alt: "بوكيه صابون على شكل ورود بيضاء وكريمية وخضراء بتغليف أنيق",
  },
  {
    src: w13,
    title: "بوكس الهدايا المتكامل",
    tag: "هدايا مؤسسية",
    alt: "بوكس خشبي كبير يجمع صابون ليان وشموع ومنشفة وورود صناعية",
  },
  {
    src: w3,
    title: "بوكس الهدايا الخشبي",
    tag: "بوكسات مميزة",
    alt: "بوكس خشبي يحتوي قطع صابون ليان بألوان الليلكي والوردي",
  },
  {
    src: w12,
    title: "بوكيه الصابون الطبيعي",
    tag: "صابون طبيعي",
    alt: "بوكيه صابون ليان مغلّف يدويًا مع زهور بيضاء وتغليف ليلكي",
  },
  {
    src: w8,
    title: "علبة الديزي والورد",
    tag: "توزيعات راقية",
    alt: "علبة هدية شفافة تحتوي صابون على شكل زهرة ديزي بيضاء وورود وردية",
  },
  {
    src: w14,
    title: "توزيعات المواليد",
    tag: "استقبال مولود",
    alt: "توزيعات صابون على شكل ملابس أطفال وعربات أطفال بالأزرق والأخضر",
  },
  {
    src: w1,
    title: "صندوق التوزيعات الكلاسيكي",
    tag: "أعياد ومناسبات",
    alt: "صندوق خشبي شفاف بشريطة كتان يحتوي صابون ليان وورود مجففة",
  },
  {
    src: w15,
    title: "كرات الورد الباستيل",
    tag: "توزيعات صابون الورد",
    alt: "توزيعات صابون على شكل ورود وكرات ورد بألوان الباستيل المتنوعة",
  },
  {
    src: w16,
    title: "تغليف الظرف المزهّر",
    tag: "توزيعات بشعار ليان",
    alt: "قطع صابون مغلّفة بورق مزهّر وملصق ليان بألوان وردية وليلكية",
  },
  {
    src: w17,
    title: "توزيعات المولود بالتاج",
    tag: "مباركة ومناسبات",
    alt: "توزيعات صابون بلون التيفاني على أعواد مع بطاقات دائرية وشرائط ساتان",
  },
  {
    src: w18,
    title: "بوكيه اللافندر والأبيض",
    tag: "بوكيهات فاخرة",
    alt: "بوكيهان من صابون الورد بلون بنفسجي وأبيض بتغليف ليلكي وذهبي",
  },
  {
    src: w19,
    title: "بوكيه اللؤلؤ الذهبي",
    tag: "هدايا مميزة",
    alt: "بوكيه صابون بلون ذهبي وأبيض مع سلسلة لؤلؤ وتغليف تُل وردي",
  },
  {
    src: w21,
    title: "تغليف الورد الكلاسيكي",
    tag: "توزيعات كميات",
    alt: "قطع صابون مغلّفة بورق كلاسيكي بنقشات ورد وردية",
  },
  {
    src: w22,
    title: "ورود الروز الكبيرة",
    tag: "صابون منحوت يدويًا",
    alt: "قطع صابون على شكل ورود كبيرة بلون الروز مرتّبة بانتظام",
  },
  {
    src: w23,
    title: "علب الشريطة الوردية",
    tag: "توزيعات أفراح",
    alt: "قطع صابون مغلّفة بورق أبيض مزهّر ومربوطة بشريط ساتان وردي",
  },
  {
    src: w24,
    title: "توزيعات التخرج الباستيل",
    tag: "تخرّج",
    alt: "قطع صابون على شكل قبعة تخرج وشهادة بألوان الباستيل مرتّبة بصفوف",
  },
  {
    src: w25,
    title: "صابون عبّاد الشمس الطبيعي",
    tag: "صابون طبيعي",
    alt: "قطعتا صابون طبيعي بلون أخضر منقوش بزهور عبّاد الشمس مع اللافندر والعسل",
  },
  {
    src: w26,
    title: "توزيعات الأفراح البيضاء",
    tag: "توزيعات أفراح",
    alt: "قطع صابون بيضاء على شكل قلوب وأيادٍ متشابكة لتوزيعات الزفاف",
  },
  {
    src: w27,
    title: "توزيعات تخرّج ديزي",
    tag: "تخرّج",
    alt: "صابون على شكل زهرة ديزي بيضاء مغلّف مع بطاقة تخرّج وشريطة وردية",
  },
  {
    src: w28,
    title: "صينية الورد المنحوت",
    tag: "صابون منحوت يدويًا",
    alt: "صينية خشبية بها قطع صابون على شكل ورود وأوراق بألوان وردية وخضراء",
  },
  {
    src: w29,
    title: "علب عروستنا",
    tag: "توزيعات أفراح",
    alt: "علب بيضاء بها صابون أخضر على شكل زهرة مع بطاقة مخصصة للعروس",
  },
  {
    src: w30,
    title: "بوكس العروس الفاخر",
    tag: "هدايا مناسبات",
    alt: "بوكس خشبي به باقة صابون ورد تركوازية وصابون جوت ميلك وباتشولي من ليان",
  },
  {
    src: w31,
    title: "بوكيه البنفسج الملكي",
    tag: "الأكثر طلبًا",
    alt: "بوكيهات صابون بزهرة بنفسجية كبيرة بتغليف وردي وذهبي",
  },
  {
    src: w32,
    title: "بوكس مبروك التخرّج",
    tag: "تخرّج",
    alt: "بوكس خشبي به صابون لافندر وشيا بتر من ليان مع بطاقة مبروك التخرج",
  },
];


export function Works() {
  const reveal = useReveal<HTMLDivElement>();
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollBy = useCallback((dir: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const amount = Math.min(el.clientWidth * 0.8, 520);
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  }, []);

  return (
    <section id="works" className="bg-l-secondary/40 py-16 lg:py-24">
      <div ref={reveal.ref} className={reveal.className}>
        <div className="container-liane">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div className="max-w-xl">
              <span className="inline-flex items-center rounded-full border border-l-border bg-l-card px-3 py-1 text-xs font-semibold tracking-wide text-l-accent-strong">
                من صنع أيدينا
              </span>
              <h2 className="mt-4 text-2xl font-bold leading-tight text-l-primary sm:text-3xl lg:text-4xl">
                أعمالنا
              </h2>
              <p className="mt-3 text-base leading-relaxed text-l-muted-foreground sm:text-lg">
                صور حقيقية ١٠٠٪ من طلبات سابقة سلّمناها لعملائنا — كل قطعة مصنوعة ومغلّفة يدويًا.
              </p>
            </div>

            <div className="hidden items-center gap-2 md:flex">
              <button
                type="button"
                aria-label="السابق"
                onClick={() => scrollBy(1)}
                className="grid size-11 place-items-center rounded-full border border-l-border bg-l-card text-l-primary transition-colors hover:bg-l-accent/20"
              >
                <ChevronRight className="size-5" />
              </button>
              <button
                type="button"
                aria-label="التالي"
                onClick={() => scrollBy(-1)}
                className="grid size-11 place-items-center rounded-full border border-l-border bg-l-card text-l-primary transition-colors hover:bg-l-accent/20"
              >
                <ChevronLeft className="size-5" />
              </button>
            </div>
          </div>
        </div>

        <div
          ref={trackRef}
          className="l-scroller mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto px-[max(1rem,calc((100vw-72rem)/2))] pb-4 sm:gap-6"
        >
          {works.map((work, i) => (
            <figure
              key={work.src}
              className="group relative w-[78vw] max-w-[340px] shrink-0 snap-start overflow-hidden rounded-3xl border border-l-border bg-l-card shadow-l-soft sm:w-[340px]"
            >
              <div className="aspect-[4/5] overflow-hidden bg-l-secondary/60">
                <img
                  src={work.src}
                  alt={work.alt}
                  width={340}
                  height={425}
                  loading={i < 2 ? "eager" : "lazy"}
                  {...{ fetchpriority: i === 0 ? "high" : "low" }}
                  decoding="async"
                  className="size-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

              </div>
              <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-l-foreground/85 via-l-foreground/35 to-transparent p-5 pt-14 text-l-card">
                <span className="text-[11px] font-semibold uppercase tracking-widest text-l-accent">
                  {work.tag}
                </span>
                <h3 className="mt-1 text-lg font-bold leading-snug">{work.title}</h3>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="container-liane mt-8 text-center">
          <a
            href={whatsappLink("مرحبًا ليان، شفت أعمالكم وحاب أطلب تصميم مشابه ✨")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-12 items-center justify-center rounded-full bg-l-primary px-7 text-sm font-semibold text-l-primary-foreground transition-opacity hover:opacity-90 sm:text-base"
          >
            اطلب تصميمًا مشابهًا
          </a>
        </div>
      </div>
    </section>
  );
}
